<section [formGroup]="form">
  <div *ngIf="index === 0">
    <h5 class="no-margin" [innerHTML]="'$evaluation_discomfort_details_introduction_1' | translate"></h5>
    <p  [innerHTML]="'$evaluation_discomfort_details_introduction_2' | translate"></p>
  </div>

  <div class="row" [formGroupName]="type">
    <ng-container *ngIf="question">
      <mat-label class="h6 question-label col-xs-12">{{question.label}}</mat-label>
      <mat-form-field class="col-xs-4" *ngFor="let childQuestion of question.childQuestions">
        <mat-select [placeholder]="childQuestion.label" [formControlName]="question.id+'-'+childQuestion.id">
          <mat-option [value]=""></mat-option>
          <mat-option *ngFor="let childAnswer of childQuestion.answers" [value]="childAnswer">{{childAnswer.label}}</mat-option>
        </mat-select>
      </mat-form-field>
    </ng-container>
  </div>
</section>